function parse(version) {
    const m = /^(\d+)\.(\d+)\.(\d+)/.exec(version.trim());
    if (m === null)
        return undefined;
    return { major: Number(m[1]), minor: Number(m[2]), patch: Number(m[3]) };
}
/** -1 if a<b, 0 if equal, 1 if a>b. */
export function compareVersions(a, b) {
    if (a.major !== b.major)
        return a.major < b.major ? -1 : 1;
    if (a.minor !== b.minor)
        return a.minor < b.minor ? -1 : 1;
    if (a.patch !== b.patch)
        return a.patch < b.patch ? -1 : 1;
    return 0;
}
export function evaluateUpdate(input) {
    const current = parse(input.current);
    const min = parse(input.policy.minSupported);
    // A build whose own version cannot be parsed, or a malformed floor, is treated as below the floor.
    if (current === undefined || min === undefined) {
        return { decision: 'required', messageId: 'app.update.required' };
    }
    if (compareVersions(current, min) < 0) {
        return { decision: 'required', messageId: 'app.update.required' };
    }
    const latest = input.policy.latest !== undefined ? parse(input.policy.latest) : undefined;
    if (latest !== undefined && compareVersions(current, latest) < 0) {
        return { decision: 'recommended', messageId: 'app.update.recommended' };
    }
    return { decision: 'ok' };
}
//# sourceMappingURL=update.js.map